import { render, staticRenderFns } from "./Aduanas.vue?vue&type=template&id=4b309e18"
import script from "./Aduanas.vue?vue&type=script&lang=js"
export * from "./Aduanas.vue?vue&type=script&lang=js"
import style0 from "./Aduanas.vue?vue&type=style&index=0&id=4b309e18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports